<script setup lang="ts">
import { ref } from 'vue'
import PointMall from './PointMall.vue'
import Mooncake from './Mooncake.vue'
import Cave from './Cave.vue'
import NianMonster from './NianMonster.vue'

const curTab = ref('nian')
</script>

<template>
  <div class="activity">
    <el-tabs v-model="curTab" type="border-card">
      <el-tab-pane label="共斗年兽" name="nian" class="pane">
        <NianMonster class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="秘藏洞窟" name="cave" class="pane" lazy>
        <Cave class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="豪吃饺子" name="dragon" class="pane" lazy>
        <Mooncake class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="积分商城" name="mall" class="pane" lazy>
        <PointMall class="pane-item" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss" scoped>
.activity {
  h4 {
    position: relative;
    .help-info {
      position: absolute;
      top: 2px;
      right: 10px;
    }
  }
  .border-wrap {
    padding: 10px;
    p {
      font-size: 14px;
      margin: 5px 0;
    }
  }
  .btn-wrap {
    & > div {
      justify-content: unset;
    }
    .common-btn-wrap {
      margin-bottom: 10px;
    }
  }
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        padding: 5px;
        flex: 1;
        .pane {
          height: 100%;
          overflow: auto;
          display: flex;
          flex-flow: column nowrap;
          .pane-item {
            height: 100%;
            overflow: auto;
            display: flex;
            flex-flow: column nowrap;
          }
        }
      }
    }
  }
}
</style>
